'use strict';

import {EwSiteApp} from '../../app/ewsiteapp';

EwSiteApp.controller('uvischeckCtrl', ['$scope', '$http', '$filter', '$uibModal', '$log', '$sce', '$interval', '$timeout', function ($scope, $http, $filter, $uibModal, $log, $sce, $interval, $timeout) {
		$scope.statusUrl = jsUvischeck.statusUrl;
		$scope.nr = '';
		$scope.status = '';
		$scope.checking_nr = false;
		$scope.displayStatus = 0;
		$scope.explicitlyTrustedHtml = function (text) {
			return $sce.trustAsHtml(text);
		};

//		$scope.onlyNumbers = function (event) {
//			var charCode = (event.which) ? event.which : event.keyCode;
//			if (charCode < 48 || charCode > 57) {
//				event.preventDefault();
//			}
//		};

		$scope.checkStatus = function () {
			$scope.checking_nr = true;
			$scope.error_message = false;
			$scope.nrNotFound = false;
			$scope.status = '';
			if ($scope.statusUrl !== '') {
				$http({
					method: 'POST',
					url: $scope.statusUrl,
					data: {
						nr: $scope.nr
					},
					xsrfCookieName: secure_xsrf_name,
					xsrfHeaderName: 'X-' + secure_xsrf_name
				}).then(function (response) {
					if (response.data.success) {
						$scope.status = response.data.status;
						//Priimta
//						$scope.status = 0;
//						
						//Vykdoma
//						$scope.status = 1;
//						
						//Atlikta
//						$scope.status = 2;
//						
						//atsaukta
//						$scope.status = 4;
						$scope.displayStatus = 1;
					} else {
						if (response.data.message === '') {
							$scope.error_message = false;
							$scope.nrNotFound = true;
						} else {
							$scope.error_message = true;
						}
					}
				}, function (response) {
					console.log(['Error', response]);
				}).then(function () {
					$scope.checking_nr = false;
				});
			}
		};

	}]);